// extracted by mini-css-extract-plugin
module.exports = {"socialLogins":"SocialLogins_socialLogins__FlfL2","socialLoginsExpander":"SocialLogins_socialLoginsExpander__Mxsc2"};